import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { SearchInput } from 'components';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    display: 'flex',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)

  },
  search: {
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  componentsSearch: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const EmpresaToolbar = props => {
  const { className, filterEmpresas, ...rest } = props;
  const [filterValue, setFilterValue] = useState('');

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.componentsSearch}>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={10}
            xs={12}
          >
            <SearchInput
              className={classes.searchInput}
              placeholder="Pesquise pela razão social, nome fantasia ou CNPJ"
              onChange={e => setFilterValue(e.target.value)}
              onKeyPress={(ev) => {
                if (ev.key === 'Enter') {
                  // Do code here
                  ev.preventDefault();
                  filterEmpresas(filterValue);
                }
              }}
            />
          </Grid>
          <Grid
            item
            md={2}
            xs={12}
          >
            <Button
              style={{width: '100%'}}
              color="primary"
              variant="contained"
              onClick={e => filterEmpresas(filterValue)}
            >
              Pesquisar
            </Button>
          </Grid>

        </Grid>
      </div>
    </div>
  );
};

EmpresaToolbar.propTypes = {
  className: PropTypes.string
};

export default EmpresaToolbar;
